// ========================================
// Widget: RRHH — tarjeta común de los widgets del panel (rejilla, arrastre en modo
// edición, controles de tamaño y navegación al pulsar). Los widgets nuevos del panel
// (pendientes, permisos, coste, semana, altas y bajas, plantilla, justificantes) la usan
// para no repetir este envoltorio; estilos en assets/css/views/rrhh-panel.css.
// ========================================

window.DashboardWidgets = window.DashboardWidgets || {};
window.DashboardWidgets.rrhh = window.DashboardWidgets.rrhh || {};

/**
 * @param {{ id: string, span: number, controls: string, displayStyle: string, isEditMode: boolean }} ctx
 * @param {string} inner the widget's content
 * @param {{ navigate?: string, className?: string }} [options] where a click leads (outside edit mode)
 */
window.DashboardWidgets.rrhh.card = function(ctx, inner, options = {}) {
    const { id, span, controls, displayStyle, isEditMode } = ctx;
    const clickable = !!options.navigate && !isEditMode;
    return `
        <div id="widget-${id}" data-widget-id="${id}" draggable="${isEditMode ? 'true' : 'false'}"
             class="dnr-card dashboard-widget-card rp-card ${options.className || ''} ${isEditMode ? 'edit-mode' : ''} ${clickable ? 'dnr-clickable' : ''}"
             style="grid-column: span ${span}; display: ${displayStyle};"
             ${clickable ? UIEvents.attr("click", function(event,captured){if(event.target.closest('button,a,input,select'))return;App.navigate(String(captured[0]));}, [options.navigate]) : ''}>
            ${controls}
            ${inner}
        </div>`;
};

/** «12 oct» for a YYYY-MM-DD date. */
window.DashboardWidgets.rrhh.shortDate = function(iso) {
    const d = new Date(`${String(iso).slice(0, 10)}T12:00:00`);
    return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' }).replace('.', '');
};
